// Presentational upload prompt for the slip importer
function ImportUploadState({onFileChange, isNative = false, onNativePick}) {
  const btnStyle = {width:"100%",padding:"14px",background:"linear-gradient(135deg,#1d4ed8,#4f46e5)",borderRadius:10,color:"#fff",fontSize:14,fontWeight:800,fontFamily:"inherit",textAlign:"center"};

  return (
    <div style={{background:"#060e1b",borderRadius:14,border:"2px dashed #1e293b",padding:"28px 20px",textAlign:"center",marginBottom:16}}>
      <div style={{fontSize:36,marginBottom:10}}>📸</div>
      <div style={{fontSize:14,fontWeight:700,color:"#94a3b8",marginBottom:6}}>Import Bet Slip</div>
      <div style={{fontSize:12,color:"#334155",lineHeight:1.6,marginBottom:20}}>
        Upload a screenshot from FanDuel, DraftKings, or BetMGM.
      </div>

      {isNative ? (
        <button type="button" onClick={onNativePick} style={{...btnStyle,border:"none",cursor:"pointer",display:"block",width:"100%"}}>
          📂 Choose Screenshot
        </button>
      ) : (
        <label style={{display:"block",width:"100%",cursor:"pointer"}}>
          <div style={btnStyle}>
            📂 Choose Screenshot
          </div>
          <input
            type="file"
            accept="image/*"
            capture={false}
            onChange={onFileChange}
            style={{display:"none"}}
          />
        </label>
      )}
      <div style={{fontSize:10,color:"#334155",textAlign:"center",marginTop:6}}>Select a screenshot to import</div>
    </div>
  );
}

export default ImportUploadState;
